import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout'
// import { parseRouteArray } from '@/utils/route'
import store from '@/store'

// import Layout from '@/layout'

export const constantRoutes = [

    {
        path: '/',
        name: 'Home',
        desc: '首页',
        component: Layout, // 假设Layout是必需的，用于包裹首页内容
        redirect: '/index', // 保持重定向到'/index'，但实际没有定义子路由了
    },
   
    {
        path: '/product',
        name: 'Product',
        desc: '产品',
        component: Layout, // 假设Layout是必需的，用于包裹首页内容
        redirect: '/product', // 保持重定向到'/index'，但实际没有定义子路由了
    },
    {
        path: '/price',
        name: 'price',
        desc: '价格',
        component: Layout, // 假设Layout是必需的，用于包裹首页内容
        redirect: '/price', // 保持重定向到'/index'，但实际没有定义子路由了
    },
    {
        path: '/ad',
        name: 'Ad',
        desc: '广告',
        component: Layout, // 假设Layout是必需的，用于包裹首页内容
        redirect: '/ad', // 保持重定向到'/index'，但实际没有定义子路由了
    },
    {
        path: '/aboutUs',
        name: 'AboutUs',
        desc: '关于',
        component: Layout, // 假设Layout是必需的，用于包裹首页内容
        redirect: '/aboutUs', // 保持重定向到'/index'，但实际没有定义子路由了
    },
    {
        path: '/',
        name: 'Home',
        desc: '首页',
        component: Layout,
        redirect: '/index',
        children: [
            {
                path: 'index',
                name: 'Index',
                desc: '首页详情',
                component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
            }
        ]
    },
    {
        path: '/product',
        name: 'Product',
        desc: '产品',
        component: Layout,
        redirect: '/product/detail',
        children: [
            {
                path: 'detail',
                name: 'ProductDetail',
                desc: '关于详情',
                component: () => import(/* webpackChunkName: "about" */ '../views/Product.vue')
            }
        ]
    },
    {
        path: '/price',
        name: 'price',
        desc: '价格',
        component: Layout,
        redirect: '/price/detail',
        children: [
            {
                path: 'detail',
                name: 'priceDetail',
                desc: '价格详情',
                component: () => import(/* webpackChunkName: "about" */ '../views/price.vue')
            }
        ]
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Layout,
        redirect: '/privacy/detail',
        children: [
            {
                path: 'detail',
                name: 'privacyDetail',
                desc: '关于详情',
                component: () => import(/* webpackChunkName: "about" */ '../views/privacy.vue')
            }
        ]
    },
    {
        path: '/sp-api-compliance',
        name: 'spApiCompliance',
        component: Layout,
        redirect: '/sp-api-compliance/detail',
        children: [
            {
                path: 'detail',
                name: 'spApiComplianceDetail',
                desc: 'SP-API 合规说明',
                component: () => import(/* webpackChunkName: "about" */ '../views/SpApiCompliance.vue')
            }
        ]
    },
    {
        path: '/user',
        name: 'user',
        component: Layout,
        redirect: '/user/detail',
        children: [
            {
                path: 'detail',
                name: 'userDetail',
                desc: '关于详情',
                component: () => import(/* webpackChunkName: "about" */ '../views/user.vue')
            }
        ]
    },
    {
        path: '/ad',
        name: 'Ad',
        desc: '广告',
        component: Layout,
        redirect: '/ad/detail',
        children: [
            {
                path: 'detail',
                name: 'AdDetail',
                desc: '关于详情',
                component: () => import(/* webpackChunkName: "about" */ '../views/Ad.vue')
            }
        ]
    },
    {
        path: '/aboutUs',
        name: 'AboutUs',
        desc: '关于',
        component: Layout,
        redirect: '/aboutUs/detail',
        children: [
            {
                path: 'detail',
                name: 'AboutUsDetail',
                desc: '关于详情',
                component: () => import(/* webpackChunkName: "about" */ '../views/AboutUs.vue')
            }
        ]
    },
    {
        path: '/brand-analytics',
        name: 'BrandAnalytics',
        desc: '品牌分析',
        component: Layout,
        redirect: '/brand-analytics/detail',
        children: [
            {
                path: 'detail',
                name: 'BrandAnalyticsDetail',
                desc: '品牌分析详情',
                component: () => import(/* webpackChunkName: "about" */ '../views/BrandAnalytics.vue')
            }
        ]
    },
    {
        path: '/nest',
        name: 'Nest',
        component: Layout,
        desc: '嵌套测试',
        // 如果有子路由必须声明重定向，并且当前 component 中必须有 <router-view />
        redirect: '/nest/one/one',
        children: [
            {
                path: 'one',
                name: 'NestOne',
                desc: '嵌套1',
                redirect: '/nest/one/one',
                component: () => import('@/views/nest/NestOne'),
                children: [
                    {
                        path: 'one',
                        name: 'NestOneOne',
                        desc: '嵌套1-1',
                        component: () => import('@/views/nest/NestOneOne'),
                    },
                    {
                        path: 'two',
                        name: 'NestOneTwo',
                        desc: '嵌套1-2',
                        component: () => import('@/views/nest/NestOneTwo'),
                    },
                ],
            },
            {
                path: 'two',
                name: 'NestTwo',
                desc: '嵌套2',
                component: () => import('@/views/nest/NestTwo'),
            }
        ],
    },

]

let copyArray = JSON.parse(JSON.stringify(constantRoutes));

store.dispatch(('routes/setRoutes'), copyArray);
// let array = parseRouteArray(copyArray);
// console.log('constantRoutes ===> ', array);

const router = createRouter({
    history: createWebHashHistory(),
    routes: constantRoutes
})

router.beforeEach((to, from, next) => {
    const url = window.location.href;
    const queryParams = {};
  
    // 先解析 # 之前的查询参数
    const hashIndex = url.indexOf('#');
    const queryStringBeforeHash = hashIndex > -1 ? url.slice(url.indexOf('?') + 1, hashIndex) : url.slice(url.indexOf('?') + 1);
    const paramsBeforeHash = queryStringBeforeHash.split('&');
    paramsBeforeHash.forEach(param => {
      const [key, value] = param.split('=');
      if (key) {
        queryParams[key] = value;
      }
    });
  
    // 再解析 # 之后的查询参数
    const queryStringAfterHash = to.fullPath.split('?')[1];
    if (queryStringAfterHash) {
      const paramsAfterHash = queryStringAfterHash.split('&');
      paramsAfterHash.forEach(param => {
        const [key, value] = param.split('=');
        if (key) {
          queryParams[key] = value;
        }
      });
    }
  
    const { code } = queryParams;
    if (code && window.location.hostname === 'localhost') {
      const newUrl = `http://localhost/advertisement/authorize?code=${code}`;
      window.location.href = newUrl;
      return;
    }
  
    next();
  });

export default router
